export const TOGGLE_THEME = "TOGGLE_THEME";
export const LOADING = "LOADING";
export const SET_LOADING = "SET_LOADING";
export const SHOW_SNACKBAR = "SHOW_SNACKBAR";
export const SHOW_SNACKBAR_INDEEP = "SHOW_SNACKBAR_INDEEP";
export const HIDE_SNACKBAR = "HIDE_SNACKBAR";
export const INITIALLY_RENDERED = "INITIALLY_RENDERED";
export const SHOW_MODAL = "SHOW_MODAL";

export const SET_PROJECT_DATA = "SET_PROJECT_DATA";
export const SET_KOL_DATA = "SET_KOL_DATA";
export const SET_CAMPAIGN_DATA = "SET_CAMPAIGN_DATA";
export const SET_ALL_CAMPAIGN_DATA = "SET_ALL_CAMPAIGN_DATA";
export const SET_IS_USER = "SET_IS_USER";
export const SET_TABLE_DATA = "SET_TABLE_DATA";
export const SET_CLAIMABLE_DATA = "SET_CLAIMABLE_DATA";
export const SET_INVESTMENT_DATA = "SET_INVESTMENT_DATA";
export const SET_ERROR_DATA = "SET_ERROR_DATA";
export const SET_GRAPHQL_DATA = "SET_GRAPHQL_DATA";

// export const SET_SHOW_SNACKBAR = "SET_SHOW_SNACKBAR";
